export default {
  unavailable: {
    title: 'Les factures clients ne sont pas disponibles',
    description:
      "Les clients qui commandent dans vos restaurants ne peuvent pas demander de facture, il n'y a donc rien à configurer ici. Les reçus de commande et les factures que votre prestataire vous émet ne sont pas concernés.",
  },
};
